import { useState, useEffect } from "react";

const Hero2 = ({ data }) => {
    return (
        <section className="relative bg-blue-100 py-14 text-gray-800">
            <div className="w-full lg:w-[70%] lg:max-w-[1440px] mx-auto px-4 lg:px-0">
                {/* 标题 居中 */}
                <div className="max-w-xl mx-auto text-center mt-12 mb-12 max-sm:mt-0.5 max-sm:mb-6">
                    <p className="text-3xl font-semibold sm:text-4xl">
                        {data.title}
                    </p>
                </div>

                {/* items 列表 */}
                <div className="space-y-14">
                    {data.items.map((item, idx) => (
                        <div
                            key={idx}
                            className={`flex flex-col lg:flex-row shadow overflow-hidden ${idx % 2 === 1 ? "lg:flex-row-reverse" : "lg:flex-row"
                                }`}
                            style={{ minHeight: "300px", maxHeight: "420px" }}
                        >
                            {/* 内容区域 */}
                            <div
                                className={`flex-[9] bg-white px-4 py-4 sm:px-6 sm:py-6 lg:px-20 lg:py-20 flex flex-col justify-start ${idx % 2 === 0 ? "rounded-t-xl lg:rounded-l-xl lg:rounded-tr-none" : "rounded-b-xl lg:rounded-r-xl lg:rounded-bl-none"
                                    }`}
                            >
                                <h4 className="text-lg sm:text-2xl font-semibold mb-8">{item.name}</h4>
                                <div className="w-10 h-1 bg-blue-500 mb-4 rounded"></div>
                                <p className="text-gray-700 text-sm sm:text-lg leading-relaxed sm:leading-loose">{item.desc}</p>
                            </div>

                            {/* 图片区域 */}
                            {item.img && (
                                <div
                                    className={`flex-[11] overflow-hidden ${idx % 2 === 0
                                            ? "rounded-b-xl lg:rounded-r-xl lg:rounded-bl-none"
                                            : "rounded-t-xl lg:rounded-l-xl lg:rounded-tr-none"
                                        }`}
                                    style={{ minHeight: "150px" }}
                                >
                                    <img
                                        src={item.img}
                                        alt={item.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            )}
                        </div>
                      

                    ))}
                </div>
            </div>
        </section>
    );
};

export default Hero2;
